module.exports = __webpack_public_path__ + "static/media/Filled-up-arrow.04f2aeed.svg";